/**
 * Normalize country code to digits only
 * @param {string|number} countryCode - Country code in any format (e.g., "+94", "+1-68", "+1+789")
 * @returns {string} - Normalized country code (e.g., "44", "168", "1789")
 */
export const normalizeCountryCode = (countryCode) => {
  if (!countryCode) return '';
  // Remove all non-digit characters
  return String(countryCode).replace(/\D/g, '');
};

/**
 * Format phone number with country code
 * @param {string|number} countryCode 
 * @param {string|number} phoneNumber - Phone number (e.g., "761111111")
 * @returns {string} - Formatted phone number (e.g., "+94 761111111")
 */
export const formatPhoneWithCountryCode = (countryCode, phoneNumber) => {
  if (!phoneNumber) return 'N/A';
  
  // Handle cases where either value is missing
  if (!countryCode) return phoneNumber;
  
  // Convert to string and clean the country code
  // Keep only digits, removing any non-numeric characters (-, +, spaces, etc.)
  const cleanCountryCode = normalizeCountryCode(countryCode);
  const cleanPhoneNumber = String(phoneNumber).replace(/\D/g, '');
  
  // Return formatted phone number with + prefix and space for better readability
  return `+${cleanCountryCode} ${cleanPhoneNumber}`;
};
